import { DateTime } from 'luxon';
import { ITemporality } from '../system/temporality/TemporalitySystem';
import { t } from 'i18next';

const ordinals: Record<number, string> = {
  1: 'Primer',
  2: 'Segundo',
  3: 'Tercer',
  4: 'Cuarto',
  5: 'Quinto',
  6: 'Sexto',
  7: 'Séptimo',
  8: 'Octavo',
  9: 'Noveno',
  10: 'Décimo',
  11: 'Undécimo',
  12: 'Duodécimo',
};

const months: Record<number, string> = {
  1: 'Enero',
  2: 'Febrero',
  3: 'Marzo',
  4: 'Abril',
  5: 'Mayo',
  6: 'Junio',
  7: 'Julio',
  8: 'Agosto',
  9: 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre',
};

type Period = {
  from: string;
  to: string;
  name: string;
};

export function generatePeriodsByTemporality(startDate: DateTime | undefined, endDate: DateTime, temporality: ITemporality | undefined): Period[] {
  const periods: Period[] = [];
  if (temporality) {
    const monthsPerPeriod = Number(temporality.dictemp_amount);

    if (!monthsPerPeriod || isNaN(monthsPerPeriod)) {
      console.warn(`Invalid temporality: dictemp_amount must be a number representing months per period: ${monthsPerPeriod}`);
      return periods;
    }

    const fiscalName = temporality.dictemp_nombre_fiscal.toLowerCase();

    if (startDate) {
      let current = startDate.startOf('month');
      let count = 1;

      while (current <= endDate) {
        const periodEnd = current.plus({ months: monthsPerPeriod }).minus({ days: 1 }).endOf('day');

        // trimestral, semestral, etc. → ordinal basado en la posición dentro del año
        const periodNumberInYear = Math.ceil(current.month / monthsPerPeriod)

        // Si el dictemp_amount es 1 entonces significa que su temporalidad es mensual por ello se debe mostrar la lista de meses
        const name = monthsPerPeriod === 1 ? `${t(months[current.month])}` : `${t(ordinals[periodNumberInYear])} ${capitalize(fiscalName)}`;

        periods.push({
          from: current.toFormat('yyyy-MM-dd'),
          to: periodEnd < endDate ? periodEnd.toFormat('yyyy-MM-dd') : endDate.toFormat('yyyy-MM-dd'),
          name,
        });

        current = current.plus({ months: monthsPerPeriod }).startOf('month');
        count++;
      }
    }
  }

  return periods;
}

export function getPeriodNameInRange(startDate: DateTime | undefined, endDate: DateTime, temporality: ITemporality | undefined): string {
  if (temporality && startDate) {
    const monthsPerPeriod = Number(temporality.dictemp_amount);
    if (!monthsPerPeriod || isNaN(monthsPerPeriod)) {
      return t('No definido');
    }

    const month = startDate.month;
    const periodNumber = Math.ceil(month / monthsPerPeriod);

    const ordinal = ordinals[periodNumber];
    const fiscal = capitalize(temporality.dictemp_nombre_fiscal);

    return `${t(ordinal)} ${fiscal}`;
  }
  return t('Tempralidad indefinida');
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}


export function getYearBoundariesForProject(year: number, start: DateTime, end: DateTime) {
  // inicio del año
  let from = DateTime.fromObject({ year, month: 1, day: 1 }).startOf("day")
  // fin del año
  let to = DateTime.fromObject({ year, month: 12, day: 31 }).endOf("day")

  // si el año es el de inicio del proyecto, mover "from" a la fecha real de inicio
  if (year === start.year) {
    from = start
  }

  // si el año es el de fin del proyecto, mover "to" a la fecha real de fin
  if (year === end.year) {
    to = end
  }

  return { from, to }
}
